module.exports = __webpack_public_path__ + "static/media/apocogan_40s.57ac6351.mp4";